import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Immutable from "immutable";
import { translate } from "react-i18next";
import actions from "redux-form/lib/actions";
import $ from "jquery";

import { getImageUrl } from "../../lib/url";
import { price } from "../../lib/utils";
import Image from "../../component/Image";

/**
 * CartDrawerItem
 */
class CartDrawerItem extends Component {
  static propTypes = {
    item: PropTypes.instanceOf(Immutable.Map).isRequired,
    extraProduct: PropTypes.bool,
    formArrayRemove: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired
  };

  static defaultProps = {
    extraProduct: false
  };

  onClickDelete = () => {
    if (this.props.extraProduct) {
      return this.onRemoveExtraProduct(this.props.item);
    }
    return this.onRemoveProduct(this.props.item);
  };

  onRemoveProduct = product => {
    this.props.formArrayRemove("cart", "items", product.get("itemIndex"));
    $(window).trigger("debloemist.cart.updated");
    return false;
  };

  onRemoveExtraProduct = product => {
    this.props.formArrayRemove(
      "cart",
      `items[${product.get("parentItemIndex")}].extraProducts`,
      product.get("itemIndex")
    );
    $(window).trigger("debloemist.cart.updated");
    return false;
  };

  render() {
    const { item } = this.props;
    return (
      <div className={`CartDrawer__CartItem${this.props.extraProduct ? " CartDrawer__CartItem__ExtraProduct" : ""}`}>
        <Image
          src={getImageUrl({
            id: item.get("imageId"),
            versionId: item.get("imageVersionId")
          })}
          alt={item.get("title")}
        />
        <div className="CartDrawer__CartItem__Description">
          <div>
            <div className="CartDrawer__CartItem__Description__Title">{item.get("title")}</div>
            {!this.props.extraProduct && (
              <div className="CartDrawer__CartItem__Description__Quantity">
                {this.props.t("quantity")} {item.get("quantity")}
              </div>
            )}
          </div>
          <div>
            <div className="CartDrawer__CartItem__Description__Price">
              {price(item.get("priceEx") * item.get("taxMultiplier") * item.get("quantity") - item.get("discount", 0))}
            </div>
            <button className="btn btn-fa" onClick={this.onClickDelete}>
              <i className="fa fa-trash" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default translate()(
  connect(null, {
    formArrayRemove: actions.arrayRemove
  })(CartDrawerItem)
);
